import { render } from "./wos.vue?vue&type=template&id=14643efa&scoped=true"
import script from "./wos.vue?vue&type=script&lang=js"
export * from "./wos.vue?vue&type=script&lang=js"

import "./wos.vue?vue&type=style&index=0&id=14643efa&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-14643efa"]])

export default __exports__